import React from 'react';
import { jsPDF } from 'jspdf';
import theme from '../theme';

// Commissione a soglia: 10% sopra €45 di prezzo lavoratore, altrimenti €4,50 fissi
// — deve restare identica alla logica di confirm-booking-payment (Edge Function).
const COMMISSION_RATE = 0.10;
const COMMISSION_THRESHOLD_EURO = 45;
const COMMISSION_FIXED_EURO = 4.50;

function generaRicevuta(application, profile, session) {
  const doc = new jsPDF();
  const oggi = new Date().toLocaleDateString('it-IT');
  const nomeAutore = profile?.full_name || session?.user?.email;
  const isOra = application?.proposed_price && application?.agreed_hours;
  const importoDettaglio = isOra
    ? `€${application.proposed_price}/h x ${application.agreed_hours}h = €${application.amount_paid?.toFixed(2)}`
    : `€${application.amount_paid?.toFixed(2)} (importo fisso)`;
  const titolo = application?.jobs?.title || 'Prestazione occasionale';

  doc.setFontSize(22);
  doc.setTextColor(45, 122, 58);
  doc.text('Jobbetty', 105, 20, { align: 'center' });

  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text('RICEVUTA DI PRESTAZIONE OCCASIONALE', 105, 32, { align: 'center' });

  doc.setLineWidth(0.5);
  doc.setDrawColor(45, 122, 58);
  doc.line(20, 38, 190, 38);

  doc.setFontSize(11);
  doc.text(`Data: ${oggi}`, 20, 50);
  doc.text(`Prestatore: ${nomeAutore}`, 20, 62);
  doc.text(`Email: ${session?.user?.email}`, 20, 74);

  doc.line(20, 82, 190, 82);

  doc.setFontSize(12);
  doc.setTextColor(45, 122, 58);
  doc.text('DETTAGLI PRESTAZIONE', 20, 94);

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.text(`Descrizione: ${titolo}`, 20, 106);
  doc.text(`Categoria: ${application?.jobs?.category || '-'}`, 20, 118);
  doc.text(`Importo: ${importoDettaglio}`, 20, 130);
  doc.text(`Totale ricevuto: EUR ${application?.amount_paid?.toFixed(2)}`, 20, 142);

  doc.line(20, 152, 190, 152);

  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text("Prestazione occasionale ai sensi dell'art. 2222 del Codice Civile,", 20, 166);
  doc.text("resa tra privati. Compenso non soggetto a IVA.", 20, 176);

  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('Firma del prestatore: ____________________', 20, 200);
  doc.text(`${nomeAutore}`, 20, 214);

  doc.setFontSize(9);
  doc.setTextColor(150, 150, 150);
  doc.text('Documento generato da Jobbetty', 105, 280, { align: 'center' });

  doc.save(`ricevuta_${titolo.replace(/\s+/g, '_')}_${oggi.replace(/\//g, '-')}.pdf`);
}

function ReceiptCard({ application, completionMsg, profile, session, isApplicant }) {
  const priceType = completionMsg?.offer_data?.price_type;
  const tariff = application?.proposed_price;
  const hours = application?.agreed_hours;
  const amountPaid = application?.amount_paid;

  const commissionAmount = amountPaid
    ? (amountPaid >= COMMISSION_THRESHOLD_EURO ? amountPaid * COMMISSION_RATE : COMMISSION_FIXED_EURO)
    : 0;
  const totalPaidByClient = amountPaid ? (amountPaid + commissionAmount) : 0;

  return (
    <div style={{ padding: '14px 16px' }}>
      <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginBottom: 8, textAlign: 'center' }}>
        Riepilogo pagamento
      </div>

      {isApplicant ? (
        // Vista lavoratore: il numero grande è ciò che riceve (netto)
        priceType === 'ora' ? (
          <div style={{ textAlign: 'center', marginBottom: theme.spacing.md }}>
            <div style={{ fontSize: theme.font.size.base, color: '#555', marginBottom: 4 }}>
              €{tariff}/h × {hours}h
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, color: theme.colors.primary }}>
              = €{amountPaid?.toFixed(2)}
            </div>
          </div>
        ) : (
          <div style={{ textAlign: 'center', marginBottom: theme.spacing.md }}>
            <div style={{ fontSize: theme.font.size.base, color: '#555', marginBottom: 4 }}>
              Importo fisso concordato
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, color: theme.colors.primary }}>
              €{amountPaid?.toFixed(2)}
            </div>
          </div>
        )
      ) : (
        // Vista cliente pagante: il numero grande è il totale addebitato
        <div style={{ textAlign: 'center', marginBottom: theme.spacing.md }}>
          <div style={{ fontSize: theme.font.size.base, color: '#555', marginBottom: 4 }}>
            {priceType === 'ora' ? `€${tariff}/h × ${hours}h` : 'Importo concordato'} = €{amountPaid?.toFixed(2)}
            {' '}<span style={{ color: theme.colors.textMuted }}>+ commissione Jobbetty (€{commissionAmount.toFixed(2)})</span>
          </div>
          <div style={{ fontSize: 32, fontWeight: 700, color: theme.colors.primary }}>
            = €{totalPaidByClient.toFixed(2)}
          </div>
          <div style={{ fontSize: theme.font.size.xs, color: theme.colors.textMuted, marginTop: 4 }}>
            Totale addebitato sulla tua carta
          </div>
        </div>
      )}

      {isApplicant && (
        <div style={{ borderTop: '1px solid #eee', paddingTop: 10, fontSize: theme.font.size.xs, color: '#aaa', textAlign: 'center', marginBottom: theme.spacing.md }}>
          Importo da corrispondere al lavoratore
        </div>
      )}

      {isApplicant && (
        <button
          onClick={() => generaRicevuta(application, profile, session)}
          style={{
            width: '100%', background: theme.colors.primary, color: theme.colors.white,
            border: 'none', borderRadius: theme.radius.sm, padding: '10px',
            fontSize: theme.font.size.md, fontWeight: 700, cursor: 'pointer'
          }}>
          📄 Scarica ricevuta
        </button>
      )}
    </div>
  );
}

export default ReceiptCard;